// extracted by mini-css-extract-plugin
export default {"v2Drawer":"v2Drawer--AdKYV","markerAnimationScale":"markerAnimationScale--I3znS"};